import PropTypes from 'prop-types';
import React from 'react';

import { colors } from '../../../common/styles/style-constants';

const CleanerMouth = ({ color }) => (
  <svg width="17" height="15" xmlns="http://www.w3.org/2000/svg">
    <g fill={color} fillRule="evenodd">
      <path d="M11.205 4.881c2.745 0 4.985 2.263 4.985 5.03 0 2.775-2.24 5.037-4.985 5.037-2.753 0-4.985-2.264-4.985-5.037 0-2.765 2.232-5.03 4.985-5.03zm0 .952c-2.233 0-4.033 1.822-4.033 4.078 0 2.265 1.8 4.084 4.033 4.084 2.223 0 4.033-1.82 4.033-4.084 0-2.255-1.81-4.078-4.033-4.078zM3.757 0c2.072 0 3.75 1.704 3.75 3.787 0 2.092-1.678 3.802-3.75 3.802C1.687 7.59 0 5.88 0 3.787 0 1.704 1.686 0 3.757 0zm0 .952C2.206.952.952 2.212.952 3.787c0 1.586 1.254 2.85 2.805 2.85 1.552 0 2.798-1.264 2.798-2.85 0-1.574-1.246-2.835-2.798-2.835z" />
      <path d="M9.848 6.79a.477.477 0 0 1 .225.885c-1.322.808-1.73 2.835-.419 4.05v.001a.473.473 0 0 1 .03.678.478.478 0 0 1-.679.02c-1.77-1.64-1.28-4.428.57-5.561a.48.48 0 0 1 .273-.074zM3.057 1.6a.476.476 0 0 1 .286.853c-.507.404-.743.82-.779 1.244-.035.424.129.914.618 1.478a.474.474 0 0 1-.048.671.476.476 0 0 1-.672-.047c-.604-.697-.907-1.447-.846-2.18.06-.733.482-1.391 1.133-1.91v-.001a.48.48 0 0 1 .308-.108z" />
    </g>
  </svg>
);
CleanerMouth.defaultProps = {
  color: colors.blue,
};

CleanerMouth.propTypes = {
  color: PropTypes.string,
};

export default CleanerMouth;
